import React, { useEffect, useState } from 'react';

import FieldDropdownIcon from '@atlaskit/icon/core/field-dropdown';
import PageIcon from '@atlaskit/icon/core/page';
import Image from '@atlaskit/image';
import { getCustomIconUrl, useProductDependencies } from '@atlassian/company-hub-common';

import { ITEM, type ItemType } from '../../../../../../types';

export const IconComponent = ({ item }: { item: ItemType }): React.JSX.Element => {
	const [externalIconUrl, setExternalIconUrl] = useState('');
	const link = item.type === ITEM.LINK ? item.link : '';
	const { submitError } = useProductDependencies();

	useEffect(() => {
		const fetchIconComponent = async () => {
			if (link) {
				const url = await getCustomIconUrl(link, submitError);
				if (url) {
					setExternalIconUrl(url);
				}
			}
		};
		void fetchIconComponent();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [link]);

	if (externalIconUrl) {
		return <Image src={externalIconUrl} height={16} width={16} alt="" />;
	}

	if (item.type === ITEM.LINK) {
		return <PageIcon label="" />;
	}

	return <FieldDropdownIcon label="" />;
};
